import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBananas: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bananas, fruits"><path d="M17.5 14C19 12.5 19.3375 10.7159 19.5 10L18.5 9.25C14.8876 10.9725 10.25 11.8491 6.75 8.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6.50088 3.75L3.50088 4.24851V7.74328C0.870065 11.3755 3.79644 18.3228 10.0674 19.9164C16.3383 21.5101 21.5009 17.0544 21.5009 13.7343L20.5954 12.8655C14.7387 15.8941 7.34051 15.5941 6.50098 7.5L6.50088 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBananas;
